import { createFileRoute } from '@tanstack/react-router';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/compra')({
    beforeLoad: () => {
        return validateRoute({
            fintech: false,
            validatePermission: ({ upp_compra_compra }) => isPermissionFull(upp_compra_compra),
        });
    },
});
